/**
 * 舒尔特方格成绩本地存储
 * key: schulte:<mode>，每个模式独立记录；仅保留最新 30 条
 * 用时越小越好
 */
const PREFIX = 'schulte:'

export function loadRecords (mode) {
  try {
    const raw = window.localStorage.getItem(PREFIX + mode)
    if (!raw) return []
    const arr = JSON.parse(raw)
    return Array.isArray(arr) ? arr : []
  } catch (e) {
    return []
  }
}

/**
 * 保存一次成绩
 * @returns { records: 最新30条, percentile: 超越历史百分比, first: 是否首次记录 }
 */
export function saveRecord (mode, time) {
  const prev = loadRecords(mode)
  // 超越：当前用时严格小于多少比例的历史成绩（越小越快越好）
  const beats = prev.filter(r => time < r).length
  const percentile = prev.length ? Math.round((beats / prev.length) * 100) : 100
  const records = prev.concat(time).slice(-30)
  try {
    window.localStorage.setItem(PREFIX + mode, JSON.stringify(records))
  } catch (e) {}
  return { records, percentile, first: prev.length === 0 }
}
